export const Crmroutes = {
  Login: { path: "/login" },
  ProductView: { path: "/product-view" },
  Message: { path: "/chat-box" },
  AllMessage: { path: "/chat-box-all" },
  AddProduct: { path: "/add-item" },
  Profile: { path: "/profile" },
  Blog: { path: "/blog" },
  Article: { path: "/blog/article/:id" },
  // Real Estate Inventory Pages
  ResidentialLeasing: { path: "/inventory/residential-leasing" },
  ResidentialSale: { path: "/inventory/residential-sale" },
  CommercialLeasing: { path: "/inventory/commercial-leasing" },
  CommercialSale: { path: "/inventory/commercial-sale" },
  HotelsLeasing: { path: "/inventory/hotels-leasing" },
  HotelsSale: { path: "/inventory/hotels-sale" },
  CommercialEntitiesSale: { path: "/inventory/commercial-entities-sale" },
  LandSale: { path: "/inventory/land-sale" },
  LandLeasing: { path: "/inventory/land-leasing" },
  MiscellaneousInventory: { path: "/inventory/miscellaneous" },
};